






import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'BaseAccordion',
  props: {
    open: {
      type: [String, Array],
      default: '',
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    transition: {
      type: String,
      default: '',
    },
    showChevron: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      items: [],
      openHeader: this.open,
      internalMultiple: this.multiple,
    };
  },
  computed: {
    headersAreClosed(): any {
      // @ts-ignore migrated from ui-library
      return this.$children.map((header) => header.isOpen).every((header) => header === false);
    },
  },
  watch: {
    open(newValue, oldValue) {
      if (!newValue || newValue === oldValue) return;
      const activeHeader = this.$children.find(
        // @ts-ignore migrated from ui-library
        (accordionItem) => accordionItem.header === newValue,
      );
      // @ts-ignore migrated from ui-library
      this.toggleHandler(activeHeader._uid);
    },
  },
  created() {
    this.setAccordionItems();
    this.setAsOpen();
  },
  mounted() {
    this.$on('toggle', this.toggleHandler);
    this.setAccordionItems();
    this.setAsOpen();
    this.$emit('click:open-header');
  },
  updated() {
    this.setAccordionItems();
    this.$emit('click:open-header');
  },
  methods: {
    setAccordionItems() {
      if (this.$children && this.$children.length) {
        // @ts-ignore migrated from ui-library
        this.items = this.$children;
      }
    },
    setAsOpen() {
      if (this.$children && this.$children.length) {
        if (this.open === 'all') {
          this.internalMultiple = true;
          // @ts-ignore migrated from ui-library
          this.openHeader = this.items.map((child) => child.header);
        }
        this.items.forEach((child) => {
          // @ts-ignore migrated from ui-library
          child.isOpen = Array.isArray(this.openHeader)
            ? // @ts-ignore migrated from ui-library
              this.openHeader.includes(child.header)
            : // @ts-ignore migrated from ui-library
              this.openHeader === child.header;
        });
      }
    },
    // @ts-ignore migrated from ui-library
    toggleHandler(slotId) {
      if (!this.internalMultiple && !Array.isArray(this.openHeader)) {
        this.items.forEach((child) => {
          // @ts-ignore migrated from ui-library
          if (child._uid === slotId) {
            // @ts-ignore migrated from ui-library
            child.isOpen = !child.isOpen;
            // @ts-ignore migrated from ui-library
            this.openHeader = child.header;
            this.$emit('click:open', this.openHeader);
          } else {
            // @ts-ignore migrated from ui-library
            child.isOpen = false;
          }
        });
      } else {
        const clickedHeader = this.items.find((child) => {
          // @ts-ignore migrated from ui-library
          return child._uid === slotId;
        });
        // @ts-ignore migrated from ui-library
        clickedHeader.isOpen = !clickedHeader.isOpen;
        // @ts-ignore migrated from ui-library
        this.$emit('click:open', clickedHeader.isOpen);
      }
      if (this.headersAreClosed) {
        this.openHeader = '';
      }
    },
  },
});
